$(document).ready(function () {
  $('.current-year').html(new Date().getFullYear())

  $('#js-rotating').Morphext({
    // The [in] animation type. Refer to Animate.css for a list of available animations.
    animation: 'fadeInDown',
    // An array of phrases to rotate are created based on this separator. Change it if you wish to separate the phrases differently (e.g. So Simple | Very Doge | Much Wow | Such Cool).
    separator: ',',
    // The delay between the changing of each phrase in milliseconds.
    speed: 4000,
    complete: function () {
      // Called after the entrance animation is executed.
    },
  })

  $('#js-rotating2').Morphext({
    // The [in] animation type. Refer to Animate.css for a list of available animations.
    animation: 'fadeInUp',
    // An array of phrases to rotate are created based on this separator. Change it if you wish to separate the phrases differently (e.g. So Simple | Very Doge | Much Wow | Such Cool).
    separator: ',',
    // The delay between the changing of each phrase in milliseconds.
    speed: 4000,
    complete: function () {
      // Called after the entrance animation is executed.
    },
  })

  const header = $('body > header')
  const nav = $('body > header > nav')

  // The sticky-nav + spacer logic only applies to public marketing pages
  // (landing / pricing / contact / policy) where `body > header` contains a
  // `<nav>` child. App pages render `header.main` (no `<nav>`), so we bail
  // out — otherwise we'd inject a stray `<div class="empty">` spacer at the
  // top of the application chrome.
  let empty = $()
  if (nav.length > 0) {
    const nav_height = nav.height()
    header.prepend('<div class="empty" style="height:0px"></div>')
    empty = header.find('.empty')

    const sticky_nav = function (scrollTop) {
      const bodyDom = nav.closest('body')
      const isPolicyPage = bodyDom.hasClass('policy')

      if (isPolicyPage) {
        empty.remove()
        if (scrollTop > 0) {
          bodyDom.find('section nav-container').addClass('sticky')
        } else {
          bodyDom.find('section nav-container').removeClass('sticky')
        }
      } else {
        if (scrollTop > 0) {
          nav.addClass('sticky')
          empty.css('height', nav_height)
        } else {
          nav.removeClass('sticky')
          empty.css('height', 0)
        }
      }
    }

    $(window).scroll(function () {
      const scrollTop = $(window).scrollTop()
      sticky_nav(scrollTop)
    })
  }

  const getCookieValue = (name) => (
    document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
  )

  if(!getCookieValue('locale')) {
    setCookie('locale', 'en-US');
  }

  i18next
  .use(i18nextChainedBackend)
  .init({
    backend: {
      backends: [
        i18nextLocalStorageBackend,
        i18nextHttpBackend
      ],
      backendOptions: [
      {
        expirationTime: 10 * 24 * 60 * 60 * 1000, // 10 days,
        defaultVersion: '19',
      },
      {
        loadPath: '/languages/{{lng}}.json',
      }
    ]
    },
    fallbackLng: 'en-US',
    lng: getCookieValue('locale') || 'en-US',
    debug: true,
  }, function(err, t) {
    moment.locale(getCookieValue('locale') || 'en-US');
    // initialized and ready to go!
  });

  function setCookie(cookieName, cookieValue, expirationDays) {
    var d = new Date();
    d.setTime(d.getTime() + (expirationDays*24*60*60*1000));
    var expires = "maxAge="+ d.toUTCString();
    document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
  }
})
